'use client';
import React from 'react';
import Link from 'next/link';
import { Home } from 'lucide-react';

interface HomeButtonProps {
  className?: string;
  label?: string;
}

export default function HomeButton({ className = '', label = 'Home' }: HomeButtonProps) {
  return (
    <Link
      href="/"
      className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-600 transition-all duration-150 active:scale-95 hover:opacity-80 ${className}`}
      style={{
        background: 'var(--secondary)',
        border: '1px solid var(--border)',
        color: 'var(--muted-foreground)',
      }}
    >
      <Home size={15} />
      <span>{label}</span>
    </Link>
  );
}
